const VIDEO_DATA = [
  {
    id: 'video-11',
    index: 1,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/ac308a21abcb4c639be0dd8a14ddedeb.mp4',
    width: 1920,
    height: 1080,
    orientation: 'landscape',
    posterSrc: '',
    title: 'LOPKIN in a real yard',
    type: 'OWNER VIDEO',
    caption: 'Autonomous mowing captured in an everyday backyard'
  },
  {
    id: 'video-12',
    index: 2,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/112ed64eaae14cbba3d7efc0b61d635e.mp4',
    width: 1080,
    height: 1920,
    orientation: 'portrait',
    posterSrc: '',
    title: 'LOPKIN at work',
    type: 'FIELD TEST',
    caption: 'A closer look at LOPKIN mowing a real lawn'
  },
  {
    id: 'video-09',
    index: 3,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/ea328149644e45659ebcbd247e638b7d.mp4',
    width: 1920,
    height: 1080,
    orientation: 'landscape',
    posterSrc: '',
    title: 'Around the garden beds',
    type: 'FIELD TEST',
    caption: 'Mowing close to beds and borders in a real backyard'
  },
  {
    id: 'video-13',
    index: 4,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/4db39eab9ca64d8699c3861700efb110.mp4',
    width: 1080,
    height: 1920,
    orientation: 'portrait',
    posterSrc: '',
    title: 'Real yard, real results',
    type: 'OWNER VIDEO',
    caption: 'Everyday mowing with LOPKIN in a live backyard'
  },
  {
    id: 'video-04',
    index: 5,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/6ce4a1b1ca65428a894d077ee84798ab.mp4',
    width: 720,
    height: 1280,
    orientation: 'portrait',
    posterSrc: '',
    title: 'Quiet work around the yard',
    type: 'FIELD TEST',
    caption: 'Everyday mowing while life continues nearby'
  },
  {
    id: 'video-10',
    index: 6,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/0054ebdcd16146ce8d31c2e71773d0cf.mp4',
    width: 1280,
    height: 720,
    orientation: 'landscape',
    posterSrc: '',
    title: 'Late afternoon in the yard',
    type: 'OWNER VIDEO',
    caption: 'Quiet mowing while the yard stays ready for the evening'
  },
  {
    id: 'video-03',
    index: 7,
    videoSrc: 'https://cdn.shopify.com/videos/c/o/v/10e63dee4fd14cf5983302229d122a1c.mp4',
    width: 1080,
    height: 1920,
    orientation: 'portrait',
    posterSrc: '',
    title: 'Mapping a real backyard',
    type: 'SETUP STORY',
    caption: 'Defining zones and boundaries in a live yard'
  }
];

function getDisplayVideos() {
  return VIDEO_DATA.slice();
}

(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getItemOrientation(item) {
    if (item.orientation) return item.orientation;
    if (item.width && item.height) {
      return item.width >= item.height ? 'landscape' : 'portrait';
    }
    return 'landscape';
  }

  function initLpUgcCompact(root) {
    if (!root || root.dataset.lpUgcReady === 'true') return;

    var els = {
      strip: root.querySelector('[data-lp-ugc-strip]'),
      prev: root.querySelector('[data-lp-ugc-prev]'),
      next: root.querySelector('[data-lp-ugc-next]'),
      lightbox: root.querySelector('[data-lp-ugc-lightbox]'),
      lightboxVideo: root.querySelector('[data-lp-ugc-lightbox-video]'),
      lightboxCaption: root.querySelector('[data-lp-ugc-lightbox-caption]'),
      lightboxClose: root.querySelector('[data-lp-ugc-lightbox-close]')
    };

    if (!els.strip) return;
    root.dataset.lpUgcReady = 'true';

    var activePreviewCard = null;
    var dragMoved = false;

    function supportsHoverPlay() {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches && !prefersReducedMotion();
    }

    function stopCardPreview(card) {
      if (!card) return;
      var preview = card.querySelector('.lp-ugc-compact__preview-video');
      card.classList.remove('is-previewing');
      if (preview) {
        preview.pause();
        preview.removeAttribute('src');
        preview.load();
      }
      if (activePreviewCard === card) activePreviewCard = null;
    }

    function stopAllPreviews() {
      root.querySelectorAll('.lp-ugc-compact__card.is-previewing').forEach(stopCardPreview);
    }

    function buildPosterHTML(item) {
      if (item.posterSrc) {
        return '<img class="lp-ugc-compact__poster-img" src="' + item.posterSrc + '" alt="" decoding="async" loading="lazy">';
      }

      if (item.videoSrc) {
        return (
          '<video class="lp-ugc-compact__poster-video" data-src="' + item.videoSrc + '#t=0.1" muted playsinline preload="none" disablePictureInPicture tabindex="-1" aria-hidden="true"></video>'
        );
      }

      return '<div class="lp-ugc-compact__poster-skeleton" aria-hidden="true"></div>';
    }

    function attachPoster(video) {
      if (!video || video.dataset.lpAttached === '1') return;
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.dataset.lpAttached = '1';
      video.preload = 'metadata';
      video.addEventListener('loadeddata', function () {
        var poster = video.closest('.lp-ugc-compact__poster');
        if (poster) poster.classList.add('has-cover');
        video.classList.add('is-ready');
      }, { once: true });
      video.src = src;
    }

    function observePosters() {
      var videos = root.querySelectorAll('.lp-ugc-compact__poster-video[data-src]');
      if (!videos.length) return;
      if (!('IntersectionObserver' in window)) {
        videos.forEach(attachPoster);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          attachPoster(entry.target);
          io.unobserve(entry.target);
        });
      }, { rootMargin: '240px 0px', threshold: 0.01 });
      videos.forEach(function (video) {
        io.observe(video);
      });
    }

    function applyCardMetrics(card, item) {
      if (!card || !item) return;
      var orientation = getItemOrientation(item);
      card.classList.remove('lp-ugc-compact__card--landscape', 'lp-ugc-compact__card--portrait');
      card.classList.add('lp-ugc-compact__card--' + orientation);

      var inner = card.querySelector('.lp-ugc-compact__card-inner');
      if (inner && item.width && item.height) {
        inner.style.setProperty('--lp-card-ratio', item.width + ' / ' + item.height);
      }

      var poster = card.querySelector('.lp-ugc-compact__poster');
      if (poster && item.posterSrc) {
        poster.classList.add('has-cover');
      }
    }

    function buildCardElement(item) {
      var orientation = getItemOrientation(item);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lp-ugc-compact__card lp-ugc-compact__card--' + orientation;
      btn.setAttribute('data-video-id', item.id);
      btn.setAttribute('aria-label', 'Play video');
      btn.innerHTML =
        '<div class="lp-ugc-compact__card-inner">' +
          '<div class="lp-ugc-compact__poster">' + buildPosterHTML(item) + '</div>' +
          '<span class="lp-ugc-compact__play" aria-hidden="true">' +
            '<span class="lp-ugc-compact__play-icon">' +
              '<svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true"><path d="M5 3l10 6-10 6V3z" fill="#111"/></svg>' +
            '</span>' +
          '</span>' +
        '</div>';

      applyCardMetrics(btn, item);
      return btn;
    }

    function bindCardHover(card) {
      if (!supportsHoverPlay()) return;

      card.addEventListener('mouseenter', function () {
        if (els.lightbox && els.lightbox.classList.contains('is-open')) return;
        if (activePreviewCard && activePreviewCard !== card) stopCardPreview(activePreviewCard);

        var item = VIDEO_DATA.find(function (v) { return v.id === card.getAttribute('data-video-id'); });
        if (!item || !item.videoSrc) return;

        var poster = card.querySelector('.lp-ugc-compact__poster');
        if (!poster) return;

        var preview = card.querySelector('.lp-ugc-compact__preview-video');
        if (!preview) {
          preview = document.createElement('video');
          preview.className = 'lp-ugc-compact__preview-video';
          preview.muted = true;
          preview.playsInline = true;
          preview.loop = true;
          preview.preload = 'none';
          preview.setAttribute('aria-hidden', 'true');
          preview.setAttribute('tabindex', '-1');
          poster.appendChild(preview);
        }

        activePreviewCard = card;
        card.classList.add('is-previewing');
        if (preview.getAttribute('src') !== item.videoSrc) preview.src = item.videoSrc;
        preview.play().catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        stopCardPreview(card);
      });
    }

    function getStripGap() {
      var styles = window.getComputedStyle(els.strip);
      var gap = parseFloat(styles.columnGap || styles.gap);
      return isNaN(gap) ? 16 : gap;
    }

    function getScrollStep() {
      var card = els.strip.querySelector('.lp-ugc-compact__card');
      if (!card) return els.strip.clientWidth * 0.8;
      return card.offsetWidth + getStripGap();
    }

    function updateNavState() {
      var maxScroll = els.strip.scrollWidth - els.strip.clientWidth;
      var left = els.strip.scrollLeft;
      var atStart = left <= 2;
      var atEnd = left >= maxScroll - 2;

      if (els.prev) els.prev.disabled = atStart;
      if (els.next) els.next.disabled = atEnd;
    }

    function scrollStrip(direction) {
      var amount = getScrollStep() * direction;
      els.strip.scrollBy({
        left: amount,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    function bindDragScroll() {
      var strip = els.strip;
      var isPointerDown = false;
      var isDragging = false;
      var startX = 0;
      var startScroll = 0;
      var pointerId = null;
      var velocity = 0;
      var lastX = 0;
      var lastTime = 0;
      var inertiaId = null;
      var dragRafId = null;
      var pendingScrollLeft = 0;
      var DRAG_THRESHOLD = 10;

      function stopInertia() {
        if (inertiaId) {
          cancelAnimationFrame(inertiaId);
          inertiaId = null;
        }
      }

      function applyPendingScroll() {
        dragRafId = null;
        strip.scrollLeft = pendingScrollLeft;
      }

      function queueScroll(target) {
        pendingScrollLeft = target;
        if (!dragRafId) {
          dragRafId = requestAnimationFrame(applyPendingScroll);
        }
      }

      function startInertia(initialVelocity) {
        stopInertia();
        if (prefersReducedMotion() || Math.abs(initialVelocity) < 0.2) return;

        var v = initialVelocity;
        var lastTs = performance.now();

        function step(now) {
          var dt = Math.min(32, now - lastTs);
          lastTs = now;

          strip.scrollLeft += v * (dt / 16);
          v *= Math.pow(0.9, dt / 16);

          var maxScroll = strip.scrollWidth - strip.clientWidth;
          if (strip.scrollLeft <= 0 || strip.scrollLeft >= maxScroll) {
            v *= 0.55;
          }

          if (Math.abs(v) < 0.15) {
            inertiaId = null;
            updateNavState();
            return;
          }

          updateNavState();
          inertiaId = requestAnimationFrame(step);
        }

        inertiaId = requestAnimationFrame(step);
      }

      function beginDrag(e) {
        isDragging = true;
        dragMoved = true;
        strip.classList.add('is-dragging');
        if (strip.setPointerCapture) {
          try {
            strip.setPointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      function endDrag() {
        if (!isPointerDown && !isDragging) return;

        var didDrag = isDragging;
        isPointerDown = false;
        isDragging = false;
        pointerId = null;
        strip.classList.remove('is-dragging');

        if (dragRafId) {
          cancelAnimationFrame(dragRafId);
          dragRafId = null;
          strip.scrollLeft = pendingScrollLeft;
        }

        if (didDrag) {
          startInertia(-velocity * 18);
          window.setTimeout(function () {
            dragMoved = false;
          }, 0);
        } else {
          dragMoved = false;
        }

        updateNavState();
      }

      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        if (e.target.closest('[data-lp-ugc-prev], [data-lp-ugc-next]')) return;

        stopInertia();
        isPointerDown = true;
        isDragging = false;
        dragMoved = false;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = strip.scrollLeft;
        lastX = e.clientX;
        lastTime = performance.now();
        velocity = 0;
      });

      strip.addEventListener('pointermove', function (e) {
        if (!isPointerDown || e.pointerId !== pointerId) return;

        var delta = e.clientX - startX;
        if (!isDragging && Math.abs(delta) >= DRAG_THRESHOLD) {
          beginDrag(e);
        }
        if (!isDragging) return;

        var now = performance.now();
        var dt = now - lastTime;
        if (dt > 0) {
          velocity = (e.clientX - lastX) / dt;
        }
        lastX = e.clientX;
        lastTime = now;

        queueScroll(startScroll - delta);
      });

      strip.addEventListener('pointerup', function (e) {
        if (e.pointerId !== pointerId) return;
        if (isDragging && strip.releasePointerCapture) {
          try {
            strip.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
        endDrag();
      });

      strip.addEventListener('pointercancel', function (e) {
        if (e.pointerId !== pointerId) return;
        endDrag();
      });

      strip.addEventListener('click', function (e) {
        if (dragMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function bindRootEvents() {
      root.addEventListener('click', function (e) {
        if (dragMoved) return;
        var card = e.target.closest('[data-video-id]');
        if (!card || !root.contains(card)) return;
        var item = VIDEO_DATA.find(function (v) { return v.id === card.getAttribute('data-video-id'); });
        stopCardPreview(card);
        if (item) openLightbox(item);
      });

      if (els.prev) {
        els.prev.addEventListener('click', function () {
          scrollStrip(-1);
        });
      }

      if (els.next) {
        els.next.addEventListener('click', function () {
          scrollStrip(1);
        });
      }

      els.strip.addEventListener('scroll', updateNavState, { passive: true });

      if (els.lightbox) {
        els.lightbox.addEventListener('click', function (e) {
          if (e.target === els.lightbox) closeLightbox();
        });
      }

      if (els.lightboxClose) {
        els.lightboxClose.addEventListener('click', function () {
          closeLightbox();
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && els.lightbox && els.lightbox.classList.contains('is-open')) {
          closeLightbox();
          return;
        }

        if (!root.contains(document.activeElement) && document.activeElement !== els.strip) return;

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          scrollStrip(-1);
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          scrollStrip(1);
        }
      });

      window.addEventListener('resize', updateNavState);
    }

    function openLightbox(item) {
      if (!els.lightbox || !els.lightboxVideo) return;

      closeLightbox(false);

      if (els.lightboxCaption) {
        els.lightboxCaption.textContent = '';
        els.lightboxCaption.setAttribute('hidden', '');
      }
      els.lightbox.removeAttribute('hidden');
      els.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      els.lightboxVideo.classList.remove('is-landscape', 'is-portrait');
      els.lightboxVideo.classList.add(getItemOrientation(item) === 'portrait' ? 'is-portrait' : 'is-landscape');

      if (item.videoSrc) {
        els.lightboxVideo.src = item.videoSrc;
        if (item.posterSrc) els.lightboxVideo.poster = item.posterSrc;
        els.lightboxVideo.play().catch(function () {});
      } else {
        els.lightboxVideo.removeAttribute('src');
        els.lightboxVideo.load();
      }
    }

    function closeLightbox(restoreScroll) {
      if (!els.lightbox || !els.lightboxVideo) return;

      els.lightboxVideo.pause();
      els.lightboxVideo.removeAttribute('src');
      els.lightboxVideo.load();
      els.lightbox.classList.remove('is-open');
      els.lightbox.setAttribute('hidden', '');
      if (restoreScroll !== false) document.body.style.overflow = '';
    }

    function mountStrip() {
      els.strip.innerHTML = '';

      getDisplayVideos().forEach(function (item) {
        els.strip.appendChild(buildCardElement(item));
      });

      els.strip.querySelectorAll('.lp-ugc-compact__card').forEach(bindCardHover);
      updateNavState();
    }

    bindRootEvents();
    bindDragScroll();
    mountStrip();
    observePosters();
  }

  function bootLpUgcCompact(scope) {
    var container = scope || document;
    var roots = [];
    if (container.matches && container.matches('[data-lp-ugc-compact]')) {
      roots = [container];
    } else if (container.querySelectorAll) {
      roots = Array.prototype.slice.call(container.querySelectorAll('[data-lp-ugc-compact]'));
    }
    roots.forEach(initLpUgcCompact);
  }

  window.LpUgcCompact = {
    boot: bootLpUgcCompact,
    data: VIDEO_DATA
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootLpUgcCompact(); });
  } else {
    bootLpUgcCompact();
  }

  document.addEventListener('shopify:section:load', function (e) {
    bootLpUgcCompact(e.target);
  });
})();
